import AContainer from '../../library/ExtendedObjects/AContainer.js';
import gameData from '../../gameData.js';
import Phaser from 'phaser';
import ABCyaPhaser from '@abcya/abcya_phaser';
import FontKeys from '../../FontKeys.js';
import UIAssetKeys from '../../UIAssetKeys.js';

export default class Tile extends AContainer {
  constructor(scene, key, showTitle = false, char = null, nodeInd) {
    super(scene);

    this.key = key;
    this.showTitle = showTitle;
    this.char = char;
    this.nodeInd = nodeInd;
    this.dir;

    let type;
    if (this.key === 'Clsc') {
      type = gameData.classicSkin[Phaser.Math.Between(0, gameData.classicSkin.length - 1)];
    }
    else if (this.key === 'Camo') {
      type = gameData.camoSkin[0];
      gameData.camoSkin.push(gameData.camoSkin.shift());
    }
    else if (this.key === 'Wood') {
      type = gameData.woodSkin[0];
      gameData.woodSkin.push(gameData.woodSkin.shift());
    }
    else if (this.key === 'Sprng') {
      type = gameData.sprngSkin[0];
      gameData.sprngSkin.push(gameData.sprngSkin.shift());
    }
    else if (this.key === 'Wntr') {
      type = gameData.wntrSkin[0];
      gameData.wntrSkin.push(gameData.wntrSkin.shift());
    }
    else if (this.key === 'Neon') {
      type = gameData.neonSkin[0];
      gameData.neonSkin.push(gameData.neonSkin.shift());
    }
    else {
      type = [];
    }

    this.downX;
    this.downY;
    this.upX;
    this.upY;
    this.distX;
    this.distY;
    this.threshold = 25;
    this.isBlank;
    this.animateFlag = false;

    if (this.showTitle === true) {
      this.createTitle();
      this.createLetter();
    }
    else {
      // console.log("loading cell", this.key, rndTile);
      if (char === ' ') {
        if (this.key === 'Smr' || this.key === 'Sprng') {
          this.keyBG = this.create(7, 7, `${this.key}_Tile${type}`);
        }
        else if (this.key === 'Atm') {
          this.keyBG = this.create(7, 0, `${this.key}_Tile${type}`);
        }
        else {
          this.keyBG = this.create(0, 0, `${this.key}_Tile${type}`);
        }
      }
      else {
        if (this.key === 'Smr' || this.key === 'Sprng') {
          this.keyBG = this.create(7, 7, `${this.key}_Tile${type}`);
        }
        else if (this.key === 'Atm') {
          this.keyBG = this.create(7, 0, `${this.key}_Tile${type}`);
        }
        else if (this.key === 'Uncrn') {
          this.keyBG = this.create(0, 0, `${this.key}_Tile${type}`);

          this.createSparkles();
        }
        else if (this.key === 'Neon') {
          if (gameData.gameMode === 'upper') {
            this.keyBGunder = this.create(0, 0, `${this.key}_Tray`);
            this.keyBG = this.create(0, 0, `${this.key}_Upr_${this.char}`, this.char !== "Ñ" ? ABCyaPhaser.Images.DEFAULT_ATLAS : ABCyaPhaser.Images.LOCALIZATION_ATLAS);
          }
          else {
            this.keyBGunder = this.create(0, 0, `${this.key}_Tray`);
            this.keyBG = this.create(0, 0, `${this.key}_Lwr_${this.char}`, this.char !== "ñ" ? ABCyaPhaser.Images.DEFAULT_ATLAS : ABCyaPhaser.Images.LOCALIZATION_ATLAS);
          }
        }
        else {
          this.keyBG = this.create(0, 0, `${this.key}_Tile${type}`);
        }
      }

      this.setSize(this.keyBG.width, this.keyBG.height);
      this.shape = new Phaser.Geom.Rectangle(-this.keyBG.width / 2, -this.keyBG.height / 2, this.keyBG.width, this.keyBG.height);

      this.createLetter(this.char);
    }
  }

  createTitle() {
    let type;
    let txtKey;
    let strokeColor = "#0b0973";
    let txtY = 0;

    if (this.key === 'Clsc') {
      type = 'Classic';
      txtKey = 'classic';
    }
    else if (this.key === 'Camo') {
      type = 'Camo';
      txtKey = 'camo';
    }
    else if (this.key === 'Wood') {
      type = 'Wood';
      txtKey = 'wood';
    }
    else if (this.key === 'Sprng') {
      type = 'Spring';
      txtKey = 'spring';
      txtY = -10;
    }
    else if (this.key === 'Wntr') {
      type = 'Wntr';
      txtKey = 'winter';
      txtY = -10;
    }
    else if (this.key === 'Atm') {
      type = 'Autumn';
      txtKey = 'autumn';
      txtY = -10;
    }
    else if (this.key === 'Smr') {
      type = 'Smr';
      txtKey = 'summer';
      txtY = -10;
    }
    else if (this.key === 'Spc') {
      type = 'Space';
      txtKey = 'space';
    }
    else if (this.key === 'Uncrn') {
      type = 'Unicorn';
      txtKey = 'unicorn';
    }
    else if (this.key === 'Neon') {
      if (gameData.gameMode === 'upper') {
        type = 'Neon_Upr';
      }
      else {
        type = 'Neon_Lwr';
      }
      txtKey = 'neon';
    }

    this.title = this.scene.add.container(0,0);
    this.add(this.title);
    this.title.bg = ABCyaPhaser.Images.addImage(0,0, `Btn_${type}`, this.title);
    ABCyaPhaser.Container.setContainerInteractive(this.title, false);
    const titleTxt = ABCyaPhaser.Text.addText(62, txtY, 32, 0xffffff, FontKeys._Vice_City_Sans, ABCyaPhaser.Localization.instance.getLocalizedString("type_select_screen.types." + txtKey), this.title).setStroke(strokeColor, 4).setResolution(1.5);
    ABCyaPhaser.Buttons.convertToButton(this.title, {onClick: ()=> this.setStyle()});
  }

  createLetter(char) {
    // console.log(this.char);
    let letter;
    let letterX;
    let letterY;
    let font;
    let tint;
    let notNeon = true;

    if (char) {
      letter = char;
      let adj;
      if (gameData.gameMode === 'upper') {
        adj = 0;
      }
      else {
        adj = -7;
      }

      if (this.key === 'Clsc') {
        letterX = 0;
        letterY = 0 + adj;
        font = FontKeys._Quicksand;
        tint = '0xFFFFFF';
      }
      else if (this.key === 'Camo') {
        letterX = 0;
        letterY = 0 + adj;
        font = FontKeys._Sanchez;
        tint = '0x646566';
      }
      else if (this.key === 'Wood') {
        letterX = 0;
        letterY = 0 + adj;
        font = FontKeys._Quicksand;
        tint = '0x6D3316';
      }
      else if (this.key === 'Sprng') {
        letterX = 0;
        letterY = 0 + adj;
        font = FontKeys._Quicksand;
        tint = '0xFFFFFF';
      }
      else if (this.key === 'Wntr') {
        letterX = 0;
        letterY = 0 + adj;
        font = FontKeys._Quicksand;
        tint = '0x07002E';
      }
      else if (this.key === 'Atm') {
        letterX = 0;
        letterY = 0 + adj;
        font = FontKeys._Espresso_Dolce;
        tint = '0xF4EAB0';
      }
      else if (this.key === 'Smr') {
        letterX = 0;
        letterY = 0 + adj;
        font = FontKeys._Quicksand;
        tint = '0x8559F9';
      }
      else if (this.key === 'Spc') {
        letterX = 0;
        letterY = 0 + adj;
        font = FontKeys._Quicksand;
        tint = '0x07002E';
      }
      else if (this.key === 'Uncrn') {
        letterX = 0;
        letterY = 0 + adj;
        font = FontKeys._Quicksand;
        tint = '0xF6FED1';
      }
      else if (this.key === 'Neon') {
        notNeon = false;
      }
    }
    else {
      if (gameData.gameMode === 'upper') {
        letter = 'A';
      }
      else {
        letter = 'a';
      }

      if (this.key === 'Clsc') {
        letterX = -91;
        letterY = 0;
        font = FontKeys._Quicksand;
        tint = '0xFFFFFF';
      }
      else if (this.key === 'Camo') {
        letterX = -87;
        letterY = 3;
        font = FontKeys._Sanchez;
        tint = '0x646566';
      }
      else if (this.key === 'Wood') {
        letterX = -94;
        letterY = 0;
        font = FontKeys._Quicksand;
        tint = '0x6D3316';
      }
      else if (this.key === 'Sprng') {
        letterX = -91;
        letterY = -10;
        font = FontKeys._Quicksand;
        tint = '0xFFFFFF';
      }
      else if (this.key === 'Wntr') {
        letterX = -94;
        letterY = -14;
        font = FontKeys._Quicksand;
        tint = '0x07002E';
      }
      else if (this.key === 'Atm') {
        letterX = -89;
        letterY = 5;
        font = FontKeys._Espresso_Dolce;
        tint = '0xF4EAB0';
      }
      else if (this.key === 'Smr') {
        letterX = -95;
        letterY = -10;
        font = FontKeys._Quicksand;
        tint = '0x8559F9';
      }
      else if (this.key === 'Spc') {
        letterX = -87;
        letterY = 0;
        font = FontKeys._Quicksand;
        tint = '0x07002E';
      }
      else if (this.key === 'Uncrn') {
        letterX = -92;
        letterY = 0;
        font = FontKeys._Quicksand;
        tint = '0xF6FED1';
      }
      else if (this.key === 'Neon') {
        notNeon = false;
      }
    }

    if (notNeon) {
      let size;
      if (char) {
        size = 75;
      }
      else {
        size = 100;
      }
      this.txt = this.scene.addText(letterX, letterY, size, tint, font, letter, this, true).setResolution(1.5);
      this.txt.setPadding(3);

      if (this.key === 'Wntr') {
        this.txt.setStroke('#FFFFFF', 4);
      }
      else if (this.key === 'Smr') {
        // this.txt.setShadow(2, 2, "#000000", 5);
        this.txt.setStroke('#FFFFFF', 6);
      }
      else if (this.key === 'Spc') {
        this.txt.setStroke('#06F9F2', 4);
      }
      else if (this.key === 'Atm') {
        this.txt.setStroke('#D8662E', 4);
      }
      else if (this.key === 'Sprng') {
        this.txt.setShadow(2, 2, '#000000', 5);
        this.txt.setStroke('#1B931B', 6);
      }
      else if (this.key === 'Camo') {
        this.txt.setShadow(-1, -1, '#000000', 0);
      }
      else if (this.key === 'Uncrn') {
        this.txt.setShadow(-1, -1, '#000000', 0);
        this.txt.setPadding(6);
      }

      gameData.styleFont = font;
    }
    else {
      gameData.styleFont = FontKeys._Quicksand;
    }

    if (this.char === ' ' || this.char === '') this.isBlank = true;
  }

  setLetter(letter) {
    // console.log(this.txt);
    if (this.key !== 'Neon') {
      this.txt.text = letter;

      if (gameData.gameMode === 'upper') {
        if (this.key === 'Clsc') {
          this.txt.y = 0;
        }
        else if (this.key === 'Camo') {
          this.txt.y = 3;
        }
        else if (this.key === 'Wood') {
          this.txt.y = 0;
        }
        else if (this.key === 'Sprng') {
          this.txt.y = -10;
        }
        else if (this.key === 'Wntr') {
          this.txt.y = -14;
        }
        else if (this.key === 'Atm') {
          this.txt.y = 5;
        }
        else if (this.key === 'Smr') {
          this.txt.y = -10;
        }
        else if (this.key === 'Spc') {
          this.txt.y = 0;
        }
        else if (this.key === 'Uncrn') {
          this.txt.y = 0;
        }
      }
      else {
        if (this.key === 'Clsc') {
          this.txt.y = -10;
        }
        else if (this.key === 'Camo') {
          this.txt.y = -13;
        }
        else if (this.key === 'Wood') {
          this.txt.y = -10;
        }
        else if (this.key === 'Sprng') {
          this.txt.y = -20;
        }
        else if (this.key === 'Wntr') {
          this.txt.y = -24;
        }
        else if (this.key === 'Atm') {
          this.txt.y = -5;
        }
        else if (this.key === 'Smr') {
          this.txt.y = -20;
        }
        else if (this.key === 'Spc') {
          this.txt.y = -10;
        }
        else if (this.key === 'Uncrn') {
          this.txt.y = -10;
        }
      }
    }
    else {
      this.title.bg.setFrame(gameData.gameMode === 'upper' ? UIAssetKeys._Btn_Neon_Upr : UIAssetKeys._Btn_Neon_Lwr);
    }
  }

  setStyle() {
    gameData.gameStyle = this.key;

    this.scene.endIntro();
  }

  setDir(dir) {
    this.dir = dir;
  }


  // ////////////////////////////
  // //// PARTICLE EFFECTS //////
  // ////////////////////////////


  doEffect(passedDelay) {
    const delay = !passedDelay ? 0 : passedDelay;

    if (this.key === 'Clsc') {
      // no effect
    }
    else if (this.key === 'Camo') {
      this.getMuddy();

      // this.scene.playSound("slide_camo");
    }
    else if (this.key === 'Wood') {
      this.scene.addDelay(delay, () => {this.smoke();});

      // this.scene.playSound("slide_wood");
    }
    else if (this.key === 'Sprng') {
      this.petalBurst();

      // this.scene.playSound("slide_spring");
    }
    else if (this.key === 'Wntr') {
      // Spin on click
      // this.scene.playSound("slide_winter");
    }
    else if (this.key === 'Atm') {
      this.leafBurst();

      // this.scene.playSound("slide_autumn");
    }
    else if (this.key === 'Smr') {
      this.bouncy();

      // this.scene.playSound("slide_summer");
    }
    else if (this.key === 'Spc') {
      this.scene.addDelay(delay, () => {this.edgeParticles();});

      // this.scene.playSound("slide_space");
    }
    else if (this.key === 'Uncrn') {
      // sparkling effect
      // this.scene.playSound("slide_unicorn");
    }
    else if (this.key === 'Neon') {
      this.scene.addDelay(delay, () => {this.flicker(Phaser.Math.Between(2, 3));});

      // this.scene.playSound("slide_neon");
    }
  }

  setParticleDirection(dir) {
    // console.log(dir);

    const direction = { xMin: 0, xMax: 0, yMin: 0, yMax: 0 };
    if (dir === 'up') {
      direction.minX = -200;
      direction.maxX = 200;
      direction.minY = -200;
      direction.maxY = -500;
    }
    if (dir === 'down') {
      direction.minX = -200;
      direction.maxX = 200;
      direction.minY = -200;
      direction.maxY = 100;
    }
    if (dir === 'left') {
      direction.minX = -300;
      direction.maxX = 100;
      direction.minY = 0;
      direction.maxY = -500;
    }
    if (dir === 'right') {
      direction.minX = -100;
      direction.maxX = 300;
      direction.minY = 0;
      direction.maxY = -500;
    }

    return direction;
  }

  createSparkles() {
    // console.log("flickering", this.x, this.y);
    this.sparkles = [];

    for (let s = 0; s < 3; s++) {
      const minX = Phaser.Math.Between(0, -this.keyBG.width / 2);
      const maxX = Phaser.Math.Between(0, this.keyBG.width / 2);
      const minY = Phaser.Math.Between(0, -this.keyBG.height / 2);
      const maxY = Phaser.Math.Between(0, this.keyBG.height / 2);
      const newX = Phaser.Math.Between(minX, maxX);
      const newY = Phaser.Math.Between(minY, maxY);

      const sparkle = this.scene.addImage(newX, newY, 'Uncrn_Sprkl', this.scene.defaultAtlas, this);
      this.sparkles.push(sparkle);
      sparkle.setAlpha(0);

      this.sparkle(sparkle);
    }
  }

  sparkle(passedObj) {
    // console.log("flickering", this.x, this.y);
    const obj = passedObj;
    const del = Phaser.Math.Between(0, 1500);
    const rot = Phaser.Math.Between(0, 360);
    const time = Phaser.Math.Between(500, 2000);
    const randScale = Phaser.Math.Between(1, 2);

    const minX = Phaser.Math.Between(0, -this.keyBG.width / 2);
    const maxX = Phaser.Math.Between(0, this.keyBG.width / 2);
    const minY = Phaser.Math.Between(0, -this.keyBG.height / 2);
    const maxY = Phaser.Math.Between(0, this.keyBG.height / 2);
    obj.x = Phaser.Math.Between(minX, maxX);
    obj.y = Phaser.Math.Between(minY, maxY);

    this.scene.addTween(obj, time * 2, { angle: rot, scaleX: randScale, scaleY: randScale, delay: del }, Phaser.Math.Easing.Linear);
    this.scene.addTween(
      obj,
      time,
      { alpha: 1, delay: del, yoyo: true },
      Phaser.Math.Easing.Linear,
      () => {this.sparkle(obj);}
    );
  }

  spin() {
    // console.log("flickering", this.x, this.y);
    this.scene.killTween(this.keyBG);

    this.scene.addTween(this.keyBG, 1000, { angle: 360 }, Phaser.Math.Easing.Back.Out);
  }

  flicker(counter) {
    // console.log("staring flickering");
    if (!gameData.gameMuted) this.scene.playSound('shock').setRate(1.5);

    let count = counter;
    const randHold = Phaser.Math.Between(0, 50) + (count * 25);
    const randLength = 10 + (count * 15);
    const randAlpha = Phaser.Math.FloatBetween(.25, .75);

    count--;

    this.scene.addTween(
      this,
      randLength,
      { alpha: randAlpha, repeat: count, yoyo: true, hold: randHold },
      Phaser.Math.Easing.Quadratic.InOut, // , onRepeat:()=>{this.particleSparks()}
      () => {
        if (count > 0) {
          this.flicker(count);
        }
        else {
          this.alpha = 1;
        }
      }
    );
  }

  bouncy() {
    // console.log("flickering", this.x, this.y);
    this.scene.killTween(this.keyBG);

    this.keyBG.setAngle(15);
    this.keyBG.setScale(1.15, 1.15);
    this.scene.addTween(this.keyBG, 1000, { scaleX: 1, scaleY: 1, angle: 0 }, Phaser.Math.Easing.Elastic.Out);
  }

  getMuddy() {
    // console.log("bursting!");
    for (let r = 0; r < this.scene.grid.allTiles.length; r++) {
      this.scene.grid.allTiles[r].setDepth(2);
    }
    this.setDepth(10);

    const directions = this.setParticleDirection(this.dir);

    this.particles = this.scene.add.particles(this.scene.particleAtlas, 'SmokeParticle');
    const emitter = this.particles.createEmitter({
      speedX: { min: directions.minX, max: directions.maxX },
      speedY: { min: directions.minY, max: directions.maxY },
      scale: { start: Phaser.Math.FloatBetween(2, 4), end: 0 },

      // blendMode: 'OVERLAY',//{'SCREEN' || "ADD" || "MULTIPLY"},
      lifespan: Phaser.Math.Between(600, 800),
      gravityY: 800,

      // alpha: { min: 0, max: 1 },
      quantity: 25,
      maxParticles: 75,
    });

    this.addAt(emitter.manager, 0);
  }

  smoke() {
    // console.log("bursting!", gameData.level);
    const key = 'dustParticle1';

    const config = {
      key: 'burst',
      frames: this.scene.anims.generateFrameNames(this.scene.particleAtlas, { start: 1, end: 5, prefix: 'dustParticle' }),
      frameRate: Phaser.Math.Between(6, 12)
    };
    gameData.anim = this.scene.anims.create(config);

    this.particles = this.scene.add.particles(this.scene.particleAtlas);

    const emitter = this.particles.createEmitter({
      x: 0,
      y: 0,
      frame: key,
      speed: { min: -180, max: 250 },
      rotate: { min: -180, max: 180 },
      scale: { start: 1, end: 0 },
      alpha: { start: .25, end: 0 },
      lifespan: 400,
      quantity: 25,
      maxParticles: 75,
      particleClass: AnimatedParticle,
      emitZone: { source: this.shape }
    });

    this.addAt(emitter.manager, 0);
  }

  edgeParticles() {
    // console.log("edgy!", this.keyBG.width);
    const newScale = .5;
    const newQuantity = 60;
    const newDelay = 1050;
    const shape = new Phaser.Geom.Rectangle(-this.keyBG.width / 2 + 20, -this.keyBG.height / 2 + 20, this.keyBG.width - 40, this.keyBG.height - 40);

    const particles = this.scene.add.particles(this.scene.particleAtlas);

    const emitter = particles.createEmitter({
      frame: 'blueBurst',
      scale: { start: newScale, end: 0 },
      alpha: { start: .5, end: 0 },
      blendMode: 'ADD',
      emitZone: { type: 'edge', source: shape, quantity: newQuantity }
    });

    this.add(emitter.manager);
    this.scene.addDelay(newDelay, () => {particles.destroy();});
  }

  petalBurst() {
    // console.log("flickering", this.x, this.y);
    for (let r = 0; r < this.scene.grid.allTiles.length; r++) {
      this.scene.grid.allTiles[r].setDepth(2);
    }
    this.setDepth(10);

    const directions = this.setParticleDirection(this.dir);

    const shape = new Phaser.Geom.Rectangle(-this.keyBG.width / 2 + 40, -this.keyBG.height / 2 + 40, this.keyBG.width - 40, this.keyBG.height - 30);

    this.particles = this.scene.add.particles(this.scene.particleAtlas);
    const emitter = this.particles.createEmitter({
      x: 0,
      y: 0,
      frame: { frames: ['petal1', 'petal2', 'petal3', 'petal4'], cycle: true, quantity: 1 },

      // speed: { min: 150, max: 250 },
      speedX: { min: directions.minX - 100, max: directions.maxX + 100 },
      speedY: { min: directions.minY, max: directions.maxY },
      rotate: { min: -180, max: 180 },
      scale: { start: .5, end: 1.5 },
      lifespan: 500,
      gravityY: 800,

      // alpha: {start: 1, end: 0, ease: 'Expo.easeIn'},
      quantity: 10,
      maxParticles: 10,

      // emitZone: { source: shape }
    });

    this.addAt(emitter.manager, 0);

    // this.add(emitter.manager);
    // this.scene.addDelay(1000, ()=>{this.particles.destroy();});
  }

  leafBurst() {
    // console.log("flickering", this.x, this.y);

    for (let r = 0; r < this.scene.grid.allTiles.length; r++) {
      this.scene.grid.allTiles[r].setDepth(2);
    }
    this.setDepth(10);

    const directions = this.setParticleDirection(this.dir);

    this.particles = this.scene.add.particles(this.scene.particleAtlas);
    const emitter = this.particles.createEmitter({
      x: this.x,
      y: this.y,
      frame: 'leaf',

      // speed: { min: -300, max: 300 },
      speedX: { min: directions.minX - 100, max: directions.maxX + 100 },
      speedY: { min: directions.minY, max: directions.maxY },
      rotate: { min: -180, max: 180 },
      scale: { min: .5, max: 4 },
      lifespan: 750,
      gravityY: 800,
      alpha: { start: 1, end: 0, ease: 'Expo.easeIn' },
      quantity: 10,
      maxParticles: 10,

      // emitZone: { source: shape }
    });

    // this.scene.addAt(emitter.manager, 0);
    emitter.manager.setDepth(9);

    // this.scene.addDelay(1000, ()=>{this.particles.destroy();});
  }

  rainbowBurst() {
    // console.log("flickering", this.x, this.y);
    const burst = this.scene.addImage(0, 0, 'rainbowBurst', this.scene.defaultAtlas, this);

    this.moveDown(burst);
    burst.setScale(0, 0);

    let newX;
    if (this.keyImg.width < 75) {
      newX = 1;
    }
    else if (this.keyImg.width >= 75 && this.keyImg.width <= 150) {
      newX = 1.5;
    }
    else {
      newX = 3;
    }

    this.scene.addTween(burst, 750, { scaleX: newX, scaleY: 1, alpha: 0 }, Phaser.Math.Easing.Quadratic.Out);
  }
}

class AnimatedParticle extends Phaser.GameObjects.Particles.Particle {
  constructor (emitter) {
    super(emitter);

    this.t = 0;
    this.i = 0;
  }

  update (delta, step, processors) {
    const result = super.update(delta, step, processors);

    this.t += delta;

    if (this.t >= gameData.anim.msPerFrame) {
      this.i++;

      if (this.i > gameData.anim.frames.length - 1) {
        if (gameData.anim.repeat === -1) {
          this.i = 0;
        }
        else {
          return;
        }
      }

      this.frame = gameData.anim.frames[this.i].frame;

      this.t -= gameData.anim.msPerFrame;
    }

    return result;
  }
}